import { ViewFilesProvider, UploadFilesProvider, FilesActionProvider, HttpService, LinkedFilesService } from '@lk/api'

export const makeLinkedFilesService = (http: HttpService, baseUrl: string) =>
  new LinkedFilesService(
    new FilesActionProvider(http, baseUrl),
    new ViewFilesProvider(http, baseUrl),
    new UploadFilesProvider(http, baseUrl),
  )
